export enum AffectedPackagingTypeDto {
  MultiMaterial = 0,
  PackagingComponent = 1,
  PackagingUnit = 2,
  PackagingSystem = 3
}
